import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import authReducer from './authReducer';
import serviceReducer from './servicesReducer';
import shopReducer from './shopReducer';
import cartReducer from './cartReducer';
import snackbarReducer from './snackbarReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    auth: authReducer,
    service: serviceReducer,
    shop: shopReducer,
    cart: cartReducer,
    snackbar: snackbarReducer
});

export default reducer;
